import { AuthController } from "../user-area/controllers/auth-controller";
import { AnswerQuestionResponseData } from "./types";

export class EnemExercisesApiService {
  private readonly authController: AuthController;

  constructor(authController: AuthController) {
    this.authController = authController;
  }

  private getAuthParams() {
    return this.authController.authCredentials;
  }

  private getApiUrl(_path: string): URL {
    let path = _path;
    if (!path.startsWith("/")) path = "/" + path;
    return new URL(location.origin + path);
  }

  async answerQuestion({
    exerciseId,
    questionId,
    answerId,
    isCorrect,
  }: {
    exerciseId: string;
    questionId: string;
    answerId: string;
    isCorrect: boolean;
  }): Promise<AnswerQuestionResponseData | null> {
    const url = this.getApiUrl("/api/exercises/");
    const response = await fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "answer-question",
        exercise_id: exerciseId,
        question_id: questionId,
        answer_id: answerId,
        is_correct: isCorrect ? "1" : "0",
        ...this.getAuthParams(),
      }),
    });

    if (!response.ok) {
      return null;
    }

    const { data }: { data: AnswerQuestionResponseData } =
      await response.json();
    return data;
  }

  async sendQuestionErrorReport(
    exerciseId: string,
    report: string
  ): Promise<void> {
    const authCredentials = this.authController.authCredentials;
    const url = this.getApiUrl("/api/exercises/");
    const response = await fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "question-feedback",
        token: authCredentials.token,
        uuid: authCredentials.uuid,
        question_id: exerciseId,
        feedback: report,
      }),
    });
    await response.json();
  }
}
